import i18n from '../../../i18n';

interface WidgetProps {
    widget : any
}
const Tips = ({widget} : WidgetProps) => {
    return <div className="card border-0 shadow-sm mt-3">
        <div className="card-body pb-0 payment_success_card_radius">
            <div style={{fontSize : "16px"}}>
                <div>
                    <img style={{width : "25px"}} src={widget.icon.replace("{platform}","android").replace("{size}","h")}/> <span className='fw-bold'>{widget.header}</span>
                </div>
                <ul className={`mt-3 ${i18n.language == 'ar' ? 'pe-2' : 'ps-1'} list-unstyled`}>
                    {widget.tipsList.map((item : any,index : number) => {
                        return <li style={{fontSize : "12px",lineHeight : "25px"}} key={index}>{item}</li>
                    })}
                </ul>
            </div>
        </div>
    </div>
}

export default Tips;